// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"d22926bb","254":"4cf4fae6"}[chunkId] + ".chunk.js";
};